module.exports = __webpack_public_path__ + "img/service.9257b5a5.png";